import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';

function Instruction({ text, buttonLabel, onContinue, disabled=false, progress=null, progressLabel }) {
    return (
        <Container
            maxWidth="sm"
            sx={{ backgroundColor: '#fff', padding: 2, boxShadow: 1, borderRadius: 1, mt: 4 }}
        >
            <Typography variant="body1" align="center" gutterBottom>
                {text}
            </Typography>
            {progress !== null && (
                <Box sx={{ my:2 }}>
                    <Typography variant="caption" display="block" align="center" gutterBottom>{progressLabel || 'Loading resources'} ({Math.round(progress*100)}%)</Typography>
                    <Box sx={{ height:6, bgcolor:'#eee', borderRadius:1, overflow:'hidden' }}>
                        <Box sx={{ height:'100%', width:`${progress*100}%`, bgcolor:'primary.main', transition:'width 0.3s' }} />
                    </Box>
                </Box>
            )}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button variant="contained" onClick={onContinue} disabled={disabled}>
                    {buttonLabel}
                </Button>
            </Box>
        </Container>
    );
}

export default Instruction;
